import { ItemView } from 'marionette';

import BaseViewMixin from 'app/src/views/base/BaseViewMixin';

export default ItemView.extend(BaseViewMixin);
